import {
    SET_WEB_RELAUNCH_STYLE_ENABLED,
    SET_CALCULATION,
    SET_LANGUAGE_CHOOSER_DISABLED
} from '../constants/action-types';

export const setWebRelaunchStyleEnabled = isWebRelaunchStyleEnabled => ({
    type: SET_WEB_RELAUNCH_STYLE_ENABLED,
    payload: isWebRelaunchStyleEnabled
});

export const setCalculation = calculation => ({
    type: SET_CALCULATION,
    payload: calculation
});

export const setLanguageChooserDisabled = isLanguageChooserDisabled => ({
    type: SET_LANGUAGE_CHOOSER_DISABLED,
    payload: isLanguageChooserDisabled
});
